import { render, staticRenderFns } from "./passwordResolution.vue?vue&type=template&id=08c03b02"
import script from "./passwordResolution.vue?vue&type=script&lang=js"
export * from "./passwordResolution.vue?vue&type=script&lang=js"
import style0 from "./passwordResolution.vue?vue&type=style&index=0&id=08c03b02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports